<smrts-dialog title="Trava da conta" [hasFootnote]="true">

  @if (!carregando) {
    <div class="content">
      <p-floatlabel variant="on">
        <input pInputText type="text" class="full-width" [ngModel]="conta.nome" [disabled]="true" />
        <label>Conta</label>
      </p-floatlabel>
      <p-floatlabel variant="on">
        <p-datepicker
          [(ngModel)]="dataTrava"
          [showIcon]="true"
          [showClear]="true"
          [fluid]="true"
          dateFormat="dd/mm/yy"
          appendTo="body" />
          <label>Data da trava</label>
        </p-floatlabel>
        @if (modificadoPor) {
          <p-floatlabel variant="on">
            <input pInputText type="text" class="full-width" [ngModel]="modificadoPor" [disabled]="true" />
            <label>Modificado por</label>
          </p-floatlabel>
        }
      </div>
    }

    <div footnote class="inline-element footnote">
      <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="false">
        Cancelar
      </button>
      <button class="white-text-button" mat-flat-button (click)="salvarClick()" [disabled]="carregando">
        Salvar
      </button>
    </div>

  </smrts-dialog>
